import {useTranslation} from 'react-i18next'

import {formatAccountNumber} from '~/utils/formatter'

import DrawerFieldItem from './DrawerFieldItem'
import DrawerSection from './DrawerSection'
import {PayeePropType} from '../../propTypes'

const PayeeDetailsSection = ({payee}) => {
  const {t} = useTranslation('pointsOnPayments')

  return (
    <DrawerSection
      title={t('pointsOnPayments:pointsOnPayment.drawer.payeeSectionTitle')}
    >
      <DrawerFieldItem
        label={t('pointsOnPayments:pointsOnPayment.drawer.fields.name')}
        value={payee.name}
      />
      <DrawerFieldItem
        label={t('pointsOnPayments:pointsOnPayment.drawer.fields.email')}
        value={payee.email}
      />
      <DrawerFieldItem
        label={t('pointsOnPayments:pointsOnPayment.drawer.fields.branchCode')}
        value={payee.branchCode}
      />
      <DrawerFieldItem
        label={t(
          'pointsOnPayments:pointsOnPayment.drawer.fields.accountNumber',
        )}
        value={formatAccountNumber(payee.accountNumber)}
      />
      <DrawerFieldItem
        label={t(
          'pointsOnPayments:pointsOnPayment.drawer.fields.businessNumber',
        )}
        value={payee.businessNumber}
      />
    </DrawerSection>
  )
}

PayeeDetailsSection.propTypes = {
  payee: PayeePropType.isRequired,
}

export default PayeeDetailsSection
